import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../Pages/Shared/Footer';
import Header02 from '../Pages/Shared/Header02';

const Home02Layout = () => {
    return (
        <>
            <Header02 />
            <Outlet />
            <Footer />
        </>
    );
};

export default Home02Layout;